document.addEventListener('DOMContentLoaded', function () {
  // Case Study Dropdown Interaction
  const firstCaseStudyWrapperBlock = document.querySelector('.dropdown__left--links-case-study-wrapper .dropdown__left--links-case-study-wrapper-blocks');
  if (firstCaseStudyWrapperBlock) {
      setActive(firstCaseStudyWrapperBlock);
  }

  const titleElements = document.querySelectorAll('.dropdown__left--links-block-title');
  titleElements.forEach(titleElement => {
      titleElement.addEventListener('click', () => {
          removeActiveClassFromElements(titleElements);
          setActive(titleElement);
          const dataTarget = titleElement.getAttribute('data-target');
          removeActiveClassFromElements(document.querySelectorAll('.dropdown__left--links-case-study-block'));
          const correspondingDiv = document.querySelector(dataTarget);
          if (correspondingDiv) {
              setActive(correspondingDiv);
          }
          removeActiveClassFromElements(document.querySelectorAll('.dropdown__left--links-case-study-wrapper div'));
          const wrapperWithId = document.querySelector(dataTarget);
          if (wrapperWithId) {
              setActive(wrapperWithId);
          }
      });
  });

  const caseNavItem = document.querySelector('.header__links--navigation-list-item.case-nav');
  if (caseNavItem) {
      caseNavItem.addEventListener('mouseleave', () => {
          removeActiveClassFromElements(document.querySelectorAll('.dropdown__left--links-case-study-sector-list li'));
          const firstLi = document.querySelector('.dropdown__left--links-case-study-sector-list li:first-child');
          if (firstLi) {
              setActive(firstLi);
          }
      });
  }
  
  function setActive(element) {
      element.classList.add('active');
  }

  function removeActiveClassFromElements(elements) {
      elements.forEach(element => {
          element.classList.remove('active');
      });
  }

  // Navigation List Item Overlay Interaction
  /*
  const listItems = document.querySelectorAll('.header__links--navigation-list-item');
  const overlay = document.querySelector('.header__links--navigation-list-overlay');

  listItems.forEach(listItem => {
      listItem.addEventListener('click', () => {
            const isShowing = listItem.classList.contains('active');

            if (isShowing) {
                listItem.classList.remove('active');
                overlay.style.opacity = '0';
                overlay.style.visibility = 'hidden';
            } else {
                listItems.forEach(item => {
                    item.classList.remove('active');
                });
                listItem.classList.add('active');
                overlay.style.opacity = '1';
                overlay.style.visibility = 'visible';
            }
      });
  });
  */
});